import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { childrenShape } from '@bibliocommons/bc-prop-types';
import { setFocusWithinElement } from '@bibliocommons/utils-accessibility';

import ExpandButton from './ExpandButton';

import './ExpandablePanel.scss';

const ExpandablePanel = ({ className, renderHeaderContent, renderExpandLabel, handleToggle: onToggle, children }) => {
  const [expanded, setExpanded] = useState(false);
  const [wasJustExpanded, setWasJustExpanded] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (wasJustExpanded && contentRef.current) {
      setFocusWithinElement(contentRef.current);
    }
    setWasJustExpanded(false);
  }, [wasJustExpanded]);

  const handleToggle = useCallback(() => {
    setExpanded(prev => {
      const nextExpanded = !prev;
      if (nextExpanded) {
        setWasJustExpanded(true);
      }
      if (onToggle) {
        onToggle({ expanded: nextExpanded });
      }
      return nextExpanded;
    });
  }, [onToggle]);

  return (
    <div className={cn('cp-expandable-panel panel', className)}>
      <div className="panel-heading">
        {renderHeaderContent()}
        <ExpandButton handleToggle={handleToggle} hideIcon isExpanded={expanded} renderLabel={renderExpandLabel} />
      </div>
      {expanded ? (
        <div className="panel-body" ref={contentRef}>
          {children}
        </div>
      ) : null}
    </div>
  );
};

ExpandablePanel.propTypes = {
  className: PropTypes.string,
  renderHeaderContent: PropTypes.func,
  renderExpandLabel: PropTypes.func,
  handleToggle: PropTypes.func,
  children: childrenShape
};

export default ExpandablePanel;
